import { render, staticRenderFns } from "./ButtonFix.vue?vue&type=template&id=2b22d786&scoped=true&"
import script from "./ButtonFix.vue?vue&type=script&lang=js&"
export * from "./ButtonFix.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFix.vue?vue&type=style&index=0&id=2b22d786&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b22d786",
  null
  
)

export default component.exports